import React from 'react';
import Chip from '@mui/material/Chip';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { CurrencyText } from '../input-formatters/CurrencyText';

const AgGridDebitAmountCell = ({ value, data, node }: ICellRendererParams) => {
  if (node.isRowPinned() && value) {
    return <Chip color={'success'} label={<CurrencyText value={value} />} size="small" variant="light" />;
  }
  if (data.amount <= 0 || data.amount === null || data.amount === undefined) {
    return <></>;
  }
  return <Chip color={'success'} label={<CurrencyText value={data.amount} />} size="small" variant="light" />;
};

export default AgGridDebitAmountCell;
